export default __webpack_public_path__ + "de3be89266357941f88504bd9e5027f6.obj";